module.exports = __webpack_public_path__ + "img/img2.85b85379.png";